import ClientSearchTable from './ClientSearchTable'

export default ClientSearchTable
